import { useAppSelector } from '../../../types';
import {
    loadingRoadSectionsQuery,
    roadSectionsQuery,
    selectedRoadSectionIdsQuery,
} from '../../../core/reference/queries';
import { Stack, Box } from '@mui/material';
import DispatchButton from '../../design_system/inputs/buttons/DispatchButton';
import { GenerateReference } from './GenerateReference';

export const ActionsOnSelectedRoadSections = () => {
    const selectedIds = useAppSelector(selectedRoadSectionIdsQuery);
    const hasReference = useAppSelector(roadSectionsQuery).length > 0;
    const loading = useAppSelector(loadingRoadSectionsQuery);

    return (
        // The grid's own options (Colonnes, Exporter, Densité, Filtres) float over the left of this row, so
        // everything here is right-aligned.
        <Stack sx={{ flexDirection: 'row', justifyContent: 'flex-end', m: 1.5 }}>
            {selectedIds.length > 0 ? (
                <Stack direction="row" gap={1}>
                    <DispatchButton title="reference.edit_gestionary" modalType="ROAD_SECTION_EDIT_GESTIONARY" />
                    <DispatchButton title="reference.edit_category" modalType="ROAD_SECTION_EDIT_CATEGORY" />
                    <DispatchButton title="reference.edit_traficPL" modalType="ROAD_SECTION_EDIT_TRAFIC_PL" />
                    <DispatchButton title="reference.edit_urban" modalType="ROAD_SECTION_EDIT_URBAN" />
                    <DispatchButton title="reference.edit_roadType" modalType="ROAD_SECTION_EDIT_ROAD_TYPE" />
                    <DispatchButton title="reference.edit_width" modalType="ROAD_SECTION_EDIT_WIDTH" />
                    <DispatchButton title="reference.edit_year" modalType="ROAD_SECTION_EDIT_YEAR" />
                </Stack>
            ) : (
                // With no sections yet, the empty state of the grid carries the button and its status instead.
                <Box sx={{ height: 40, display: 'flex', alignItems: 'center' }}>
                    {hasReference && !loading && <GenerateReference statusFirst />}
                </Box>
            )}
        </Stack>
    );
};
